import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail } from "lucide-react";
import { submitForm } from "@/api/apis";

export default function NewsletterSignup({invertColor=false}) {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      console.log(
        "Newsletter signup sent to contact@wearemusicnation.ae:",
        email
      );
      // Email submissions go to contact@wearemusicnation.ae

      submitForm("NewsSubscribe", { email }).then((res) => {
        setIsSubmitted(true);
      });
    }
  };

  return (
    <section className={" py-16 relative overflow-hidden " +  (invertColor ? "" : "section-red")}>
      {/* Light blob effects */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-1/4 right-1/4 w-[300px] h-[300px] bg-white/10 rounded-full filter blur-[80px]"></div>
        <div className="absolute bottom-1/3 left-1/3 w-[250px] h-[250px] bg-yellow-500/10 rounded-full filter blur-[100px]"></div>
      </div>

      {/* Noise texture */}
      <div className="noise-overlay"></div>

      <div className="red-section editorial-container relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="mail-icon bg-white/10 p-4 rounded-full">
              <Mail className="text-white" size={32} />
            </div>
          </div>

          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">
            Stay in the loop
          </h2>

          <p className="text-white/90 mb-8 text-lg">
            Get the latest news, updates, and exclusive insights delivered
            straight to your inbox.
          </p>

          {!isSubmitted ? (
            <form
              onSubmit={handleSubmit}
              className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto"
            >
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="bg-white/10 border-white/20 text-white placeholder:text-white/60 focus:border-white"
                required
              />
              <Button
                type="submit"
                className="bg-white text-musicRed hover:bg-white/90 font-medium whitespace-nowrap"
              >
                Join List
              </Button>
            </form>
          ) : (
            <div className="bg-white/10 rounded-lg p-6 max-w-md mx-auto">
              <p className="text-white text-lg font-medium">
                ✓ Thanks for subscribing!
              </p>
              <p className="text-white/80 mt-2">
                You'll hear from us soon with the latest updates.
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
